import { ACCESS } from '@src/configs/permission'
import lazyLoading from '@src/components/widgets/LazyLoading'

import { TRouteConfig } from '../routeConfig'

const List = lazyLoading(() => import('@src/pages/product-property/product-density'))
const Create = lazyLoading(() => import('@src/pages/product-property/product-density/create'))
const Detail = lazyLoading(() => import('@src/pages/product-property/product-density/detail'))

const densityRouter: TRouteConfig[] = [
  {
    path: '/list-density',
    Element: List,
    key: ACCESS.LIST_DENSITY,
  },
  {
    path: '/create-density',
    Element: Create,
    key: ACCESS.ADD_DENSITY,
  },
  {
    path: '/density/:id',
    Element: Detail,
    key: ACCESS.VIEW_DENSITY,
  },
]

export { densityRouter }
